import cn from "classnames";
import { ViewType } from "../types";
import { StarProps } from "./types";
import { COLORS, SIZES, STROKE_COLORS } from "./constants";
import styles from "./styles.scss";

export const Star = ({
  size = "medium",
  rating,
  hover,
  index,
  active,
}: StarProps) => {
  const hasHover = hover !== -1;
  let viewType: ViewType;

  if (hasHover) {
    if (index + 1 <= (hover ?? rating)) {
      viewType = "action-positive";
    } else {
      viewType = "action-negative";
    }
  } else if (index + 1 <= rating && rating !== -1) {
    viewType = "default-positive";
  } else {
    viewType = "default-negative";
  }

  if (rating === -1 && !hasHover) {
    viewType = "default";
  }

  if (index + 1 === active) {
    viewType = "click-positive";
  }

  const color = COLORS[viewType];
  const strokeColor = STROKE_COLORS[viewType];

  return (
    <svg
      fill={color}
      stroke={strokeColor}
      width={SIZES[size]}
      height={SIZES[size]}
      viewBox={`0 0 ${SIZES[size]} ${SIZES[size]}`}
      className={cn(styles.star, styles[viewType])}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M18.206 3.634c.734-1.487 2.854-1.487 3.588 0l3.619 7.333a2 2 0 0 0 1.505 1.094l8.093 1.176c1.64.238 2.295 2.254 1.108 3.411l-5.855 5.708a2 2 0 0 0-.576 1.77l1.383 8.06c.28 1.634-1.435 2.88-2.902 2.109l-7.238-3.806a2 2 0 0 0-1.862 0l-7.238 3.806c-1.467.771-3.182-.475-2.902-2.109l1.383-8.06a2 2 0 0 0-.575-1.77L3.88 16.648c-1.187-1.157-.532-3.173 1.108-3.411l8.093-1.176a2 2 0 0 0 1.505-1.094l3.62-7.333Z" />
    </svg>
  );
};
